var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDesignVector(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1062,
    height: 352,
    viewBox: "0 0 1062 352",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M186 7C83.275 7 0 156.313 0 340.5C0 344.349 0.036363 348.183 0.108509 352H11.4348C11.4028 349.398 11.3867 346.789 11.3867 344.172C11.3867 167.647 84.5399 24.5456 174.779 24.5456C265.018 24.5456 338.171 167.647 338.171 344.172C338.171 346.789 338.155 349.398 338.123 352H371.891C371.964 348.183 372 344.349 372 340.5C372 156.313 288.725 7 186 7Z",
    fill: "silver"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M381.719 352C381.905 345.876 382 339.708 382 333.5C382 284.477 376.101 237.924 365.506 196H432C439.954 235.183 470.817 266.046 510 274V352H381.719Z",
    fill: "blue"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M353.496 156C320.57 62.2749 262.341 0 196 0H510V78.0004C470.817 85.954 439.954 116.817 432 156H353.496Z",
    fill: "blue"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M510 248.304C516.367 250.061 523.074 251 530 251C536.926 251 543.633 250.061 550 248.304C575.345 241.309 595.309 221.345 602.304 196C604.061 189.633 605 182.926 605 176C605 169.074 604.061 162.367 602.304 156C595.309 130.655 575.345 110.691 550 103.696C543.633 101.939 536.926 101 530 101C523.074 101 516.367 101.939 510 103.696C484.655 110.691 464.691 130.655 457.696 156C455.939 162.367 455 169.074 455 176C455 182.926 455.939 189.633 457.696 196C464.691 221.345 484.655 241.309 510 248.304Z",
    fill: "red"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M550 352V274C589.183 266.046 620.046 235.183 628 196H656.387L585.294 352H550Z",
    fill: "blue"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M550 78.0004V0H745.709L674.616 156H628C620.046 116.817 589.183 85.954 550 78.0004Z",
    fill: "blue"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M756 0L596.291 352H677.644L796.939 90.2308L756 0Z",
    fill: "green"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M688.634 352H749.618L859.773 110.286L829.349 43.2295L802.422 102.315L688.634 352Z",
    fill: "green"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1061.43 352L911 20.4612L865.009 121.826L760.575 352H1061.43Z",
    fill: "green"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesignVector);
export default __webpack_public_path__ + "static/media/design-vector.af57cb498ed39632856341c5bff13851.svg";
export { ForwardRef as ReactComponent };